import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  SEARCH_TILE: {
    LOAD_MORE: (skip, query) => ({ skip, query }),
    API: {
      LOAD_MORE: apiResourceActionCreator('searchTileResult')
    }
  }
})

export const apiAction = (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, actions.searchTile.api.loadMore)

export function* loadMoreSearchTile(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.skip, action.payload.query));
}

const configuration = {
  name: 'loadMore',
  action: actions,
  sagas: loadMoreSearchTile,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        isFetching: true,
        isLoadingMore: true
      });
    },
    success: (state, action) => {
      const nextSearchTiles = fp.concat(state.searchTileResult.searchTiles, action.payload.searchTileResult.searchTiles);
      const nextContent = fp.concat(state.searchTileResult.content, action.payload.searchTileResult.content);
      const nextEvents = fp.concat(state.searchTileResult.events, action.payload.searchTileResult.events);
      const nextSearchTileResult = Object.assign({}, action.payload.searchTileResult, {
        content: nextContent,
        events: nextEvents,
        searchTiles: nextSearchTiles
      });
      return Object.assign({}, state, {
        isFetching: false,
        isLoadingMore: false,
        searchTileResult: nextSearchTileResult,
        error: null
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        isFetching: false,
        isLoadingMore: false,
        error: action.payload.error
      });
    }
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/configurations/loadMore.js